import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from 'firebase/messaging';
import { FIREBASE_CONFIG } from './firebase-config.js';

//initialize Firebase
const app = initializeApp(FIREBASE_CONFIG);

//checks if the app is running in a WebView
//to avoid duplicate notifications in WebView environments
const isInWebView = () => {
  const ua = navigator.userAgent || '';
  return ua.includes("MyWebViewApp");
};

//request permission for notifications and get the FCM token
//if the app is not running in a WebView
export const requestPermision = async () => {
  if (isInWebView()) {
    console.log("Skipping FCM in WebView to avoid duplicate notifications.");
    return null;
  }
  //Check if Notification permission is already granted
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn("Notification permission not granted.");
      return null;
    }

    // Only get messaging if not in WebView
    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: "BK_QAM_QYhhPxIBGXXBGFKHXVQOmviN1r7xjsxBUtBhujRrgC6KXda606WDIuYR3sR-fAikAYuNSfX9S-nf-uu4",
    });

    console.log("FCM Token:", token);
    return token;
  } catch (err) {
    console.error("Permission denied or error:", err);
    return null;
  }
}

//register the service worker for Firebase Messaging
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registration successful:', registration);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
  console.log("User Agent:", navigator.userAgent);
  console.log("Notification Supported:", 'Notification' in window);
  console.log("Service Worker Supported:", 'serviceWorker' in navigator);
  console.log("Is WebView:", isInWebView());
}